import React, { useEffect, useState } from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import PropertyDetailsSection from './section-components/property-details';
import RecomandProperties from './section-components/recomand-properties';
import Footer from './global-components/footer';
import PropertyDetailsHeader from './global-components/ProperteryDetails-header';
import { useParams } from "react-router-dom";
import PropertyDetailsList from "../JsonData/property-details.json"
import { slugify } from '../utils/slugify';
import { Helmet } from 'react-helmet';
import SimilarProperty from './section-components/property-similar';
import BlogContact from '../utils/blogContact';

const PropertyDetails = () => {

  const { propertySlug } = useParams();
  const [propertyData, setPropertyData] = useState(null);

  useEffect(() => {
    // const propertyId = Number(id);
    const foundProperty = PropertyDetailsList.PropertyDetailsList.find(
      (prop) => slugify(prop.PropertyName) === propertySlug
    );

    if (foundProperty) {
      if (!foundProperty.images || foundProperty.imagee === 0) {
        foundProperty.images = [{ src: '/assets/img/no-image.jpg' }];
      }

      setPropertyData(foundProperty);

      console.log(propertyData?.metaTitle, "metetemetemete");
    }
  }, [propertySlug]);

  //   useEffect(() => {
  //   if (propertyData) {
  //     console.log(propertyData.metaDescription, "✅ metetemetemete");
  //   }
  // }, [propertyData]);

  // console.log(propertyData, "bannnnnnerrr");
  // console.log("Banner Image:", propertyData?.images?.[0]?.src);


  return <div>
    {propertyData && (
      <Helmet>
        <title>{propertyData?.metaTitle}</title>
        <meta name="description" content={propertyData?.metaDescription} />
      </Helmet>
    )}
    <Navbar />
    {/* <PageHeader headertitle="Property Details" /> */}
    {propertyData && ( <PropertyDetailsHeader headertitle={propertyData?.PropertyName} bannerImage={propertyData?.images[0]?.src} /> )}
    {propertyData && (<PropertyDetailsSection property={propertyData} /> )} 
    <SimilarProperty
     building_type={propertyData?.building_type}
    propertyTypeList={propertyData?.propertyType?.map(p => p.type)} 
     currentPropertyId={propertyData?.id}
      />
    <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
    <Footer />
  </div>
}

export default PropertyDetails

